import React, { memo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { TEST_VIEW } from '../../../../constants/bot';

import useScrollbarGutterAuto from '../../../../hooks/useScrollbarGutterAuto';

import ChatHeader from './ChatHeader/ChatHeader';
import ApiPreview from './ApiPreview/ApiPreview';
import AssistantPreview from '../AssistantPreview/AssistantPreview';

export const CHAT_SEARCH_PARAM_KEY = 'chat';

const BotPreviewPanel = ({ botName, isInstructionEditing }) => {
    const { botId } = useParams();

    const [view, setView] = useState(TEST_VIEW.assistant);

    const [isPrevChatLoading, setIsPrevChatLoading] = useState(false);

    const panelContainerRef = useRef(null);

    useScrollbarGutterAuto();

    return (
        <div className="h-full flex flex-col" ref={panelContainerRef}>
            <ChatHeader isChatLoading={isPrevChatLoading} view={view} setView={setView} />

            <AssistantPreview
                botId={botId}
                botName={botName}
                isVisible={view === TEST_VIEW.assistant}
                panelContainerRef={panelContainerRef}
                isPrevChatLoading={isPrevChatLoading}
                setIsPrevChatLoading={setIsPrevChatLoading}
                isInstructionEditing={isInstructionEditing}
            />

            <ApiPreview
                botId={botId}
                botName={botName}
                isVisible={view === TEST_VIEW.api}
                panelContainerRef={panelContainerRef}
                isInstructionEditing={isInstructionEditing}
            />
        </div>
    );
};

export default memo(BotPreviewPanel);
